import { SCROLL_OFFSET } from './constants';
import { AnchorItem } from './types';

// Helper: Get all anchor hrefs including nested children
export const getAllAnchorHrefs = (items: AnchorItem[]): string[] => {
  const hrefs: string[] = [];
  items.forEach((item) => {
    if (item.href) {
      hrefs.push(item.href);
    }
    if (item.children) {
      item.children.forEach((child) => {
        if (child.href) {
          hrefs.push(child.href);
        }
      });
    }
  });
  return hrefs;
};

// Helper: Check if href is a child item
export const isChildItem = (
  anchorItems: AnchorItem[],
  href: string
): boolean => {
  return anchorItems.some((item) =>
    item.children?.some((child) => child.href === href)
  );
};

// Helper: Calculate scroll position for an element (same as click handler)
export const calculateScrollPosition = (
  elementTop: number,
  containerTop: number,
  currentScrollTop: number,
  containerPaddingTop: number = 0
): number => {
  // Account for container's top padding when calculating scroll position
  return (
    currentScrollTop +
    (elementTop - containerTop) -
    SCROLL_OFFSET -
    containerPaddingTop
  );
};

export const scrollDefaultToTop = (
  contentWrapperRef: React.RefObject<HTMLDivElement>
) => {
  if (!contentWrapperRef.current) {
    return;
  }
  const scrollContainer = contentWrapperRef.current?.parentNode;
  if (!(scrollContainer instanceof HTMLElement)) {
    return;
  }
  scrollContainer.scrollTo({
    top: 0,
    behavior: 'instant',
  });
};
